import * as i0 from "@angular/core";
export class TermsConditionStore {
}
TermsConditionStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TermsConditionStore_Factory() { return new TermsConditionStore(); }, token: TermsConditionStore, providedIn: "root" });
export var TermsConditionStoreKeys;
(function (TermsConditionStoreKeys) {
})(TermsConditionStoreKeys || (TermsConditionStoreKeys = {}));
